/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      minWidth: theme.spacing(32),
    },
    date: {
      paddingBottom: 8,
      color: "#333333",
      fontSize: "12px",
      lineHeight: "20px",
      opacity: "0.5",
    },
    source: {
      paddingTop: 12,
      color: "#333333",
      opacity: "0.5",
      fontSize: "12px",
      lineHeight: "20px",
    },
  });

export const useStyles = makeStyles(styles);
